import { ITag } from '../tagging/ITag';
import { IJob } from '../job/IJob';

export class SearchTerm {
  public id: string;
  public projectId: string;
  public searchTermListId: string;
  public term: string;
  public isValid: boolean;
  public job: IJob;
  public description: string;
  public tag: ITag;
  public tagWithRelated: ITag;

  constructor(id: string, projectId: string, searchTermListId?: string, term?: string, isValid?: boolean, job?: IJob, description?: string, tag?: ITag, tagWithRelated?: ITag) {
    this.id = id;
    this.projectId = projectId;
    this.searchTermListId = searchTermListId;
    this.term = term;
    this.isValid = isValid;
    this.job = job;
    this.description = description;
    this.tag = tag || null;
    this.tagWithRelated = tagWithRelated || null;
  }
}

namespace app.model.terms {

  export class SearchTerm {
    public id: string;
    public projectId: string;
    public searchTermListId: string;
    public term: string;
    public isValid: boolean;
    public job: app.model.job.IJob;
    public description: string;
    public tag: app.model.tagging.ITag;
    public tagWithRelated: app.model.tagging.ITag;

    constructor(id: string, projectId: string, searchTermListId?: string, term?: string, isValid?: boolean, job?: app.model.job.IJob, description?: string, tag?: app.model.tagging.ITag, tagWithRelated?: app.model.tagging.ITag) {
      this.id = id;
      this.projectId = projectId;
      this.searchTermListId = searchTermListId;
      this.term = term;
      this.isValid = isValid;
      this.job = job;
      this.description = description;
      this.tag = tag || null;
      this.tagWithRelated = tagWithRelated || null;
    }
  }
}
